import React from 'react';

export const ModalContext = React.createContext('ModalContext');
export const UserContext = React.createContext('UserContext');
export const PromoContext = React.createContext('PromoContext');
